import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import {
  Home,
  MessageCircle,
  Heart,
  Gift,
} from "lucide-react";
import styles from "./FeedSidebar.module.css";

interface FeedSidebarProps {
  mobileOpen?: boolean;
  onCloseMobile?: () => void;
}

export default function FeedSidebar({
  mobileOpen = false,
  onCloseMobile,
}: FeedSidebarProps) {
  const location = useLocation();
  const history = useHistory();

  const navItems = [
    {
      label: "Home Feed",
      path: "/",
      icon: <Home size={20} strokeWidth={1.8} />,
    },
    {
      label: "Messages",
      path: "/chat",
      icon: <MessageCircle size={20} strokeWidth={1.8} />,
      hasBadge: true,
    },
    {
      label: "Favorites",
      path: "/saved",
      icon: <Heart size={20} strokeWidth={1.8} />,
    },
    {
      label: "Rewards & Gifts",
      path: "/the-vault",
      icon: <Gift size={20} strokeWidth={1.8} />,
    },
  ];

  return (
    <>
      {/* Backdrop overlay for mobile drawer */}
      {mobileOpen && (
        <div className={styles.mobileOverlay} onClick={onCloseMobile} />
      )}

      <aside
        className={`${styles.sidebar} ${mobileOpen ? styles.sidebarOpen : ""}`}
      >
        <div className={styles.navSection}>
          {navItems.map((item) => {
            const isActive =
              item.path === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(item.path);

            return (
              <div key={item.label} className={styles.iconButtonWrapper}>
                <button
                  className={`${styles.iconBtn} ${
                    isActive ? styles.iconBtnActive : ""
                  }`}
                  onClick={() => {
                    if (onCloseMobile) onCloseMobile();
                    history.push(item.path);
                  }}
                  aria-label={item.label}
                >
                  {item.icon}
                  {item.hasBadge && <span className={styles.badgeDot} />}
                </button>
                <span className={styles.tooltip}>{item.label}</span>
              </div>
            );
          })}
        </div>
      </aside>
    </>
  );
}
